import React from 'react';
import List from 'pages/Orders/List';

const imported_today_filter = ({ filters, setFilters }) => {
  return (
    <label>
      Show only Orders imported today?
      <input
        className="ml-2"
        type="checkbox"
        checked={filters.order_imported_today_only}
        onChange={ev => {
          setFilters({
            ...filters,
            order_imported_today_only: ev.target.checked,
          });
        }}
      />
    </label>
  );
};

const UnassignedList = ({ ...props }) => (
  <List
    url="orders?order_status=unassigned"
    title="Unassigned Orders"
    canAssign={!props.readOnly}
    canManage={!props.readOnly}
    canView={true}
    defaultFilters={{order_imported_today_only: false}}
    {...props}
  />
);

export default UnassignedList;



// WEBPACK FOOTER //
// ./src/pages/Orders/UnassignedList.jsx